import {
  format as dateFnsFormat,
  differenceInSeconds,
  formatISO,
  getDate,
  getDay,
  getHours,
  getMinutes,
  getMonth,
  getSeconds,
  getYear,
  Locale,
} from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import { DateArray } from 'ics';
import { DateOnlyDto, DayOfWeek } from '../api';

export const getDateExpirationStatusWithOffset = (date: Date, expirationDate: Date, offsetSeconds: number): 'expired' | 'not-expired' | 'expiring' => {
  if (date === null) return 'expired';

  const gap = differenceInSeconds(expirationDate, date);
  if (gap > offsetSeconds) return 'not-expired';
  else if (gap > 0) return 'expiring';
  else return 'expired';
};

export const dateOnlyFormatISOString = (d: Date) => {
  return formatISO(d, { representation: 'date' });
};

export const getDayOfWeek = (date: Date): DayOfWeek => {
  const day = getDay(date);

  switch (day) {
    case 0:
      return DayOfWeek.Sunday;
    case 1:
      return DayOfWeek.Monday;
    case 2:
      return DayOfWeek.Tuesday;
    case 3:
      return DayOfWeek.Wednesday;
    case 4:
      return DayOfWeek.Thursday;
    case 5:
      return DayOfWeek.Friday;
    case 6:
      return DayOfWeek.Saturday;
    default:
      throw `Invalid day given to getDayOfWeek ${day}`;
  }
};

export const ensureDate = (date: Date | string): Date => {
  if (typeof date === 'string') {
    return new Date(date);
  }

  return date;
};

const locales: Record<string, Locale> = {
  fr: fr,
  en: enUS,
};
export const formatWithLang = (date: Date, format: string, lang: string) => {
  return dateFnsFormat(date, format, { locale: locales[lang] });
};

export const dateOnlyDtoToApi = (dateOnly: DateOnlyDto): DateOnlyDto => {
  return { ...dateOnly, month: dateOnly.month + 1 };
};

export const getDateWithSpecifiedTime = (date: Date, time: Date) => {
  return new Date(getYear(date), getMonth(date), getDate(date), getHours(time), getMinutes(time), getSeconds(time));
};

export const dateToIcsDateArray = (date: Date): DateArray => [getYear(date), getMonth(date) + 1, getDate(date), getHours(date), getMinutes(date)];
